import "@cloudscape-design/global-styles/index.css";
import './App.css';
import React, { useEffect } from 'react';
import { useNavigate, BrowserRouter , Route, Routes, Navigate, Link as RouterLink, useParams } from 'react-router-dom';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Grid from '@cloudscape-design/components/grid';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import HelpPanel from '@cloudscape-design/components/help-panel';
import Flashbar from '@cloudscape-design/components/flashbar';
import InstitutionApplication from './pages/institution-application';

import Navigation from './components/navigation';
import Breadcrumbs, {BreadcrumbProvider} from './components/breadcrumbs';

import Shell from './layouts/shell';

import { FormFull } from 'pages/indicator-submission/components/form'
import { TableSelectFilter } from 'pages/my-applications/index';
import ApplicationDetails from 'pages/application/index';
import ApplicationSummary from 'pages/application/application-summary';
import { useAuth } from './AuthContext';
import { AuthProvider } from './AuthContext';
import SignInForm from './Signin'
import { Amplify } from 'aws-amplify';
import AppHelpPanel from './components/help-panel';
import { variationData, breakdownItems, productionMetrics, quote, notes } from './data';
import { some } from 'lodash';

import { applyTheme } from "@cloudscape-design/components/theming";
import { brandTheme as theme } from "./theme";

const { reset } = applyTheme({ theme });


Amplify.configure({
  API: {
    GraphQL: {
      endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
      region: process.env.REACT_APP_APPSYNC_REGION,
    }
  }
});


const IndicatorSubmissionPage = () => {
  const { indicatorSubmissionID } = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" info={<Link variant="info">Indicator Submission</Link>}>
        Indicator Submission
      </Header>
    }
  >
    <FormFull indicatorSubmissionID={indicatorSubmissionID} />
  </ContentLayout>
);
}
const MyApplicationsPage = () => (
  <ContentLayout
  >
    <TableSelectFilter />
  </ContentLayout>
);


const ApplicationDetailsPage = () => {
  const{ applicationID }  = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" info={<Link variant="info">Annual Submission Summary Page</Link>}>
        Annual Submission Summary Page
      </Header>
    }
  >
    <ApplicationDetails applicationID={applicationID}/>
  </ContentLayout>
  )
};

const ApplicationSummaryPage = () => {
  const{ applicationID }  = useParams();
  return (
  <ContentLayout
    header={
      <Header variant="h1" >
        Annual Submission Summary Page
      </Header>
    }
  >
    <ApplicationSummary applicationID={applicationID}/>
    {/* <ApplicationDetailsTable loadHelpPanelContent={null} applicationID={applicationID}/> */}
  </ContentLayout>
  )
};


const NavLinks = () => (
  <div className="nav-links">
    <RouterLink to="/indicator-submission" className="nav-link">Indicator Submission</RouterLink>
    <RouterLink to="/my-submissions" className="nav-link">Annual Submissions</RouterLink>
    <RouterLink to="/application-details" className="nav-link">Annual Submission Details</RouterLink>

   
  </div>
);
export const ProtectedRoute = ({ children, requiredRole, requireProfile = true }) => {
  const { auth, hasProfile } = useAuth();
  const navigate = useNavigate();

  const handleAlertDismiss = () => {
    navigate('/institution-profile', { replace: true });
  };

  if (!auth) {
    return <Navigate to="/authentiate" replace />;
  }
  
  if (requiredRole && auth.role !== requiredRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireProfile && hasProfile === false) {
    return (
      <div style={{ padding: '20px' }}>
        <Flashbar
          items={[
            {
              type: 'info',
              header: 'Profile Required',
              content: 'Please complete your institution profile to access the application.',
              dismissible: true,
              onDismiss: handleAlertDismiss
            }
          ]}
        />
      </div>
    );
  }

  if (requireProfile && hasProfile === null) {
    return <div>Loading...</div>;
  }

  return children;
};

const ProfileRedirect = () => {
  const { hasProfile } = useAuth();
  const navigate = useNavigate();

  console.log('ProfileRedirect - hasProfile:', hasProfile);

  useEffect(() => {
    console.log('ProfileRedirect useEffect - hasProfile:', hasProfile);
    if (hasProfile === false) {
      console.log('Redirecting to institution-profile');
      navigate('/institution-profile', { replace: true });
    } else if (hasProfile === true) {
      console.log('Redirecting to my-applications');
      navigate('/my-submissions', { replace: true });
    }
  }, [hasProfile, navigate]);

  if (hasProfile === null) {
    return <div>Loading...</div>;
  }

  return null;
};

const SignOutComponent = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    navigate('/', { replace: true });
  }, []);

  return null;
};

function App() {
  return (
    <BreadcrumbProvider>
    <AuthProvider>
    <BrowserRouter>
    <div className="App">
    <Shell
        defaultPadding
        disableOverlap
        headerVariant="high-contrast"
        breadcrumbs={<Breadcrumbs />}
        navigation={<Navigation />}
        tools={<AppHelpPanel/>}
      >
          <Routes>
            <Route path="/authentiate" element={<SignInForm />} />
            <Route path="/indicator-submission/:indicatorSubmissionID" 
            element={
            <ProtectedRoute >
              <IndicatorSubmissionPage />
              </ProtectedRoute>
            } />

            <Route path="/institution-profile" 
            element={
              <ProtectedRoute requireProfile={false}>
                <InstitutionApplication />
              </ProtectedRoute>
            }
            />
            
            <Route path="/my-submissions" 
            element={
              <ProtectedRoute >
            <MyApplicationsPage />
            </ProtectedRoute>
            }
            />
            <Route path="/application-details/:applicationID" 
            element={
              <ProtectedRoute >
            <ApplicationDetailsPage />
            </ProtectedRoute>
            } />


            <Route path="/application-summary/:applicationID" 
            element={
              <ProtectedRoute >
            <ApplicationSummaryPage />
            </ProtectedRoute>
            } />

            <Route path="/" 
            element={
              <ProtectedRoute>
                <ProfileRedirect />
              </ProtectedRoute>
            } />
            <Route 
                path="/signout" 
                element={
                  <SignOutComponent />
                }
              />      
          </Routes>

    </Shell>

    </div>
    </BrowserRouter>
    </AuthProvider>
    </BreadcrumbProvider>

  );
}


export default App;
